export class AdjustLimitResponse {
	codigo: number;
	quantidadeAutorizacaoPendente: number;
	situacao: AdjustLimitSituation;
}

export enum AdjustLimitSituation {
	PEDENTE_APROVACAO = 'PENDENTE_APROVACAO',
	PEDENTE_DEMAIS_APROVACOES = 'PENDENTE_DEMAIS_APROVACOES',
	APROVADA = 'APROVADA',
	REPROVADA = 'REPROVADA',
	ERRO_PROCESSAMENTO = 'ERRO_PROCESSAMENTO'
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/limits/models/adjust-limit.ts